var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTagAlt = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m10.913 2.44 10.854 10.854-8.473 8.473-4.677-4.678v4.47h-1v-5.47L2.44 10.913V2.44h8.472Zm-.414 1H3.44v7.06l4.177 4.176v-4.39a2.227 2.227 0 0 1-1.72-2.01l-.005-.159a2.226 2.226 0 1 1 2.725 2.17v5.389l4.676 4.676 7.06-7.059-9.854-9.853Zm.207 9.147L14 15.883l-.707.707L10 13.294l.707-.707ZM13.294 10l3.296 3.295-.707.707-3.296-3.295.707-.707ZM8.117 6.892a1.226 1.226 0 1 0 0 2.451 1.226 1.226 0 0 0 0-2.451Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTagAlt);
export default ForwardRef;